/* eslint-disable */
import React from 'react';
import styled, { css } from 'styled-components';
import { useTable, useSortBy } from 'react-table';
// import { Scrollbars } from 'react-custom-scrollbars';
import { SortBy } from '../../assets/SortBy';

const StyledTable = styled.table`
  width: 100%;
  /* margin-top: 24px; */

  thead {
    tr {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      justify-items: start;

      padding: 16px 0;

      border-top: 1px solid;
      border-bottom: 1px solid;
      border-color: ${props => props.theme.bg4};

      th {
        display: flex;
        align-items: center;
        gap: 6px;

        color: ${props => props.theme.text2};
        font-weight: 400;
        font-size: 12px;

        user-select: none;

        &:last-child {
          justify-self: end;
        }
      }
    }
  }
`;

const Balance = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  height: 100%;

  h6 {
    margin: 0;

    font-family: Bebas Neue;
    font-size: 20px;
    font-weight: 600;
  }

  strong {
    margin-right: 6px;

    color: ${props => props.theme.text2};
    font-size: 12px;
    font-weight: 500;
  }

  span {
    color: #0290e6;
    font-size: 12px;
    font-weight: 500;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  height: 100%;

  button {
    height: 33px;
    padding: 8px 12px;

    background-color: #f7f7ff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);

    color: #0a090e;
    font-size: 12px;
    font-weight: 600;
  }
`;

const Asset = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const AssetPoster = styled.div`
  display: flex;
  align-items: center;

  position: relative;

  border-radius: 4px;

  overflow: hidden;

  &::after {
    content: '';
    width: ${props => props.percentage}%;
    height: 4px;

    position: absolute;
    bottom: 0;

    background-color: ${props => props.color};

    z-index: 1;
  }
`;

const AssetInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.theme.text2};
  }

  strong {
    font-size: 16px;
    font-weight: 500;
    color: ${props => props.theme.text0};
  }
`;

const AssetRow = styled.tr`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  margin-top: 20px;
`;

const sortedMixin = css`
  .arrow-up {
    fill: ${props => (props.sortedDesc ? props.theme.text2 : props.theme.text0)};
  }

  .arrow-down {
    fill: ${props => (props.sortedDesc ? props.theme.text0 : props.theme.text2)};
  }
`;

const SortIconWrapper = styled.span`
  height: 16px;

  font-size: 0;
  svg path {
    fill: ${props => props.theme.text2};
  }

  ${props => (props.sorted ? sortedMixin : '')};
`;

const data = [
  {
    actions: {
      id: '0',
    },
    asset: {
      name: 'Onomy',
      code: 'NOM',
      percentage: 70,
      imageSrc: 'https://picsum.photos/64/72',
      accentColor: '#00baff',
    },
    balance: {
      number: 14210.51,
      change: 3.2,
    },
  },
  {
    actions: {
      id: '1',
    },
    asset: {
      name: 'DogeCoin',
      code: 'DOGE',
      percentage: 12,
      imageSrc: 'https://picsum.photos/64/72',
      accentColor: '#b9aad6',
    },
    balance: {
      number: 123.55,
      change: 5.4,
    },
  },
  {
    actions: {
      id: '2',
    },
    asset: {
      name: 'Etherium',
      code: 'ETH',
      percentage: 18,
      imageSrc: 'https://picsum.photos/64/72',
      accentColor: '#e8d1bd',
    },
    balance: {
      number: 10.1,
      change: 99.9,
    },
  },
];

const columns = [
  {
    Header: 'Asset',
    accessor: 'asset',
    Cell: ({ value }) => (
      <Asset>
        <AssetPoster color={value.accentColor} percentage={value.percentage}>
          <img src={value.imageSrc} alt="" />
        </AssetPoster>
        <AssetInfo>
          <span>{value.code}</span>
          <strong>{value.name}</strong>
        </AssetInfo>
      </Asset>
    ),
  },
  {
    Header: 'Balance',
    accessor: 'balance',
    Cell: ({ value }) => (
      <Balance>
        <h6>{value.number}</h6>
        <div>
          <strong>$16,093.44</strong>
          <span>+{value.change}%</span>
        </div>
      </Balance>
    ),
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableSortBy: true,
    Cell: ({ value }) => (
      <Actions>
        <button onClick={() => alert(value.id)}>Send </button>
        <button>Receive</button>
        <button>Stake</button>
      </Actions>
    ),
  },
];

export default function AssetsTable() {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  return (
    <StyledTable {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {!column.disableSortBy && (
                  <SortIconWrapper sorted={column.isSorted} sortedDesc={column.isSortedDesc}>
                    <SortBy />
                  </SortIconWrapper>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      {/* <Scrollbars style={{ height: 500, width: 'auto' }}> */}
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);

          return (
            <AssetRow {...row.getRowProps()}>
              {row.cells.map(cell => (
                <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              ))}
            </AssetRow>
          );
        })}
      </tbody>
      {/* </Scrollbars> */}
    </StyledTable>
  );
}
